// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"305b6733","427":"a4c7892a"}[chunkId] + ".chunk.css";
};